import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthService } from './auth.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LearnsetService } from './learnset.service';
import { FlashcardService } from './flashcard.service';
import { CourseService } from './course.service';
import { DemoService } from './demo.service';
import { OnboardingService } from './onboarding.service';
import { HeaderService } from './header.service';
import { UserService } from './user.service';
import { DeviceService } from './device.service';
import { ChatService } from './chat.service';
import { SubscriptionService } from './subscription.service';
import { PdfService } from './pdf.service';
import { ExamService } from './exam.service';
import { FileService } from './file.service';

@NgModule({
  providers: [
    AuthService,
    LearnsetService,
    FlashcardService,
    CourseService,
    DemoService,
    OnboardingService,
    HeaderService,
    UserService,
    DeviceService,
    ChatService,
    SubscriptionService,
    PdfService,
    ExamService,
    FileService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true, // Register multiple interceptors
    },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    // Prevent CoreModule from being loaded multiple times
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}